// 데스크탑 메뉴용 드롭다운
  const link = document.querySelector('a[href="/collections/iphone-18-series-cases"]');

  // Create submenu container
  const submenu = document.createElement('div');
  submenu.style.display = 'none';
  submenu.style.marginLeft = '20px';
  submenu.style.marginBottom = '8px';

  // Create submenu items using only the real URLs
  const items = [
    
    { text: 'iPhone 18 Pro Max', realHref: '/collections/iphone-18-pro-max-cases' },
    { text: 'iPhone 18 Pro', realHref: '/collections/iphone-18-pro-cases' },
  ];

  items.forEach(item => {
    const a = document.createElement('a');
    a.href = item.realHref;
    a.textContent = item.text;
    a.className = 'navlink navlink--child';
    a.style.display = 'block';
    a.style.margin = '5px 0';
    a.style.color = '#000';
    a.style.fontSize = '17px';
    a.style.fontFamily = 'Poppins, sans-serif';
    a.style.lineHeight = '24px';
    a.style.fontWeight = '400';

    submenu.appendChild(a);
  });

  // Insert submenu into DOM right after the link
  link.parentNode.insertBefore(submenu, link.nextSibling);

  // Show/hide submenu on hover
  link.addEventListener('mouseenter', () => {
    submenu.style.display = 'block';
    link.style.textDecoration = 'underline';
  });

  link.addEventListener('mouseleave', () => {
    setTimeout(() => {
      if (!submenu.matches(':hover')) {
        submenu.style.display = 'none';
      }
    }, 150);
    link.style.textDecoration = 'none';
  });

  submenu.addEventListener('mouseenter', () => {
    submenu.style.display = 'block';
  });

  submenu.addEventListener('mouseleave', () => {
    submenu.style.display = 'none';
  });

  document.addEventListener("DOMContentLoaded", function () {
    const links = document.querySelectorAll(".sliderow__title");

    links.forEach(link => {
      if (link.textContent.trim() === "iPhone 18 Series") {
        const parent = link.parentElement;
        let clickTimeout = null;

        link.addEventListener("click", function (e) {
          e.preventDefault();

          if (clickTimeout) {
            // Detected a double-click
            clearTimeout(clickTimeout);
            clickTimeout = null;

            // Navigate to the link (you can customize the URL if needed)
            window.location.href = link.href || "#";
            return;
          }

          // First click: set a timeout to detect if there's a second click
          clickTimeout = setTimeout(() => {
            clickTimeout = null;

            // Toggle dropdown
            let existing = parent.querySelector(".custom-mobile-dropdown");
            if (existing) {
              existing.style.display = existing.style.display === "none" ? "flex" : "none";
              return;
            }

            // Create dropdown
            const dropdown = document.createElement("div");
            dropdown.className = "custom-mobile-dropdown";

            Object.assign(dropdown.style, {
              display: "flex",
              flexDirection: "column",
              width: "100%",
              marginTop: "8px",
              marginBottom: "8px",
              paddingLeft: "25px",
              background: "#fff",
              zIndex: "1"
            });

            const items = [
              { text: 'iPhone 18 Pro Max', href: '/collections/iphone-18-pro-max-cases' },
              { text: 'iPhone 18 Pro', href: '/collections/iphone-18-pro-cases' },
            ];

            items.forEach(item => {
              const a = document.createElement("a");
              a.textContent = item.text;
              a.href = item.href;
              Object.assign(a.style, {
                padding: "10px 0",
                color: "#000",
                textDecoration: "none",
                fontSize: "18px",
                borderBottom: "1px solid #eee"
              });
              dropdown.appendChild(a);
            });

            parent.appendChild(dropdown);

            setTimeout(() => {
              document.addEventListener("click", outsideClickListener);
            }, 10);

            function outsideClickListener(event) {
              if (!dropdown.contains(event.target) && !link.contains(event.target)) {
                dropdown.style.display = "none";
                document.removeEventListener("click", outsideClickListener);
              }
            }
          }, 250); // Adjust this delay if needed
        });
      }
    });
  });
